import React from 'react';

import { flagStyles } from '../settings';

const SvgGS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2112px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGS;
